import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import FormulaireRecuperation from "@/components/FormulaireRecuperation/FormulaireRecuperation";
import { recuperationService } from "../../pages/api/authentificationApi";
import { RECUPERATION_DATA } from "@/constants/data";
import { useAuth } from "@/composables/auth";

const VerificationCode = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const { verifyRecoveryCode, loading } = useAuth();

  const [error, setError] = useState<string>("");
  // const [email, setEmail] = useState<string>("");
  // const [context, setContext] = useState<"signup" | "reset">("signup");

  useEffect(() => {
    if (!email) {
      navigate("/recuperation-acces");
      return;
    }
  }, [navigate]);

  const handleSubmit = async (code: string) => {
    try {
      setError("");

      if (!email) {
        throw new Error("Email non disponible");
      }

      const cleanCode = code.trim();

      const token = await verifyRecoveryCode({
        email: email,
        code: cleanCode,
        isProfessional: false,
      });

      if (!token) {
        throw new Error("Code de vérification invalide ou expiré");
      }

      const path = "changer/mot-de-passe";
      //   context === "signup" ? "configuration/espace" : "changer/mot-de-passe";
      navigate(`/${path}/${encodeURIComponent(token)}`);
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("Une erreur est survenue lors de la vérification du code");
      }
    }
  };

  const handleResendCode = async () => {
    try {
      setError("");
      if (!email) {
        throw new Error("Email non disponible");
      }
      await recuperationService.sendCode(email);
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("Une erreur est survenue lors du renvoi du code");
      }
    }
  };

  return (
    <div className="py-10">
      <div className="text-center">
        <p className="text-lg italic text-[#000080]">
          Oups, un trou de mémoire ?
        </p>
        <p className="text-xl font-bold text-gray-900 mt-1">
          Pas de panique, ça arrive même aux meilleurs !
        </p>
      </div>

      <FormulaireRecuperation
        titre={RECUPERATION_DATA.code.titre}
        sousTitre={RECUPERATION_DATA.code.sousTitre}
        image={RECUPERATION_DATA.code.image}
        onSubmit={handleSubmit}
        onResendCode={handleResendCode}
        isCodePage={true}
        error={error}
        loading={loading}
      />
    </div>
  );
};

export default VerificationCode;
